<div
  id="default-page"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start">
  <div id="default-page-intro" fxFlex fxHide fxShow.gt-sm>
    <div
      class="title"
      [@animate]="{ value: '*', params: { delay: '50ms', y: '25px' } }">
      {{ 'GENERAL.TITLE.SITE' | translate }}
    </div>
  </div>
  <div
    id="default-page-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }">
    @if (isTokenValid) {
      <div id="default-page-form">
        <div class="title name-container">
          {{ 'RESET-PWD.RESETPWD' | translate }}
          {{ currentUser.officialFirstName }} {{ currentUser.officialLastName }}
        </div>
        <form name="forgoPasswordForm" [formGroup]="resetPasswordForm">
          <mat-form-field appearance="outline" class="field-container">
            <mat-label> {{ 'SECURITY.PASSWORD.TITLE' | translate }}</mat-label>
            <app-pass-visibility #toggleNew matSuffix></app-pass-visibility>
            <input
              matInput
              type="password"
              formControlName="password"
              autoComplete="on"
              [type]="toggleNew.type" />
            @if (resetPasswordForm.get('password').invalid) {
              <mat-error class="error-password">
                {{ getErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="field-container">
            <mat-label>{{
              'SECURITY.PASSWORDCONFIRMATION.TITLE' | translate
            }}</mat-label>
            <app-pass-visibility #toggleConfirm matSuffix></app-pass-visibility>
            <input
              matInput
              type="password"
              formControlName="passwordConfirmation"
              autoComplete="on"
              [type]="toggleConfirm.type" />
          </mat-form-field>
          <div class="error-container">
            @if (resetPasswordForm.hasError('passwordNotMatch')) {
              <mat-error class="message-box error">
                {{ 'ERROR.IDENTICALPSWD' | translate }}
              </mat-error>
            }
          </div>
          <button
            mat-raised-button
            class="submit-button"
            color="accent"
            (click)="resetPassword()"
            aria-label="RESET MY PASSWORD"
            [disabled]="
              resetPasswordForm.invalid || isPasswordUpdate || isBusy
            ">
            {{ 'SECURITY.FORM.SUBMIT' | translate }}
          </button>
          @if (isBusy) {
            <div
              class="general-container"
              fxLayout="column"
              fxLayoutAlign="center center">
              <mat-progress-spinner
                [color]="spinner.color"
                [mode]="spinner.mode"
                [value]="spinner.value"
                [diameter]="spinner.diameter">
              </mat-progress-spinner>
              <div class="loading-container">
                {{ 'GENERAL.LOADING' | translate }}
              </div>
            </div>
          }
          @if (errorUpdatePassword) {
            <div class="general-container">
              <div class="message-box error">
                <app-error-message [error]="error.error" />
              </div>
            </div>
          }
          @if (isPasswordUpdate) {
            <div class="general-container">
              <div class="message-box success">
                {{ 'SECURITY.FORM.CONFIRMATION' | translate }}
              </div>
            </div>
          }
        </form>
        <div class="login" fxLayout="row" fxLayoutAlign="center center">
          <a class="link" [routerLink]="'/login'">
            {{ 'SECURITY.FORM.BACK' | translate }}</a
          >
        </div>
      </div>
    }
    @if (!isTokenValid) {
      <div
        id="default-page-form-invalid"
        [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }">
        <div class="title">{{ 'ERROR.TOKEN' | translate }}</div>
        <button
          mat-raised-button
          class="submit-button btn-submit"
          color="accent"
          [routerLink]="'/password-recovery'">
          {{ 'RESET-PWD.RESET' | translate }}
        </button>
      </div>
    }
  </div>
</div>
